import { getToken } from './user-service';

const BASE_URL = '/api/v1/cpu/sla-reports/ecacDepartureSummaryReport';

class EcacDepartureSummaryReportService {
    async getEcacDepartureSummaryReport(params = {}, signal) {
        const token = await getToken();
        const { startDate, endDate, iata, hideBreakdown, requestId } = params;
        const query = new URLSearchParams({ iata, startDate, endDate });
        if (hideBreakdown) query.append('hideBreakdown', 'true');
        if (requestId) query.append('requestId', requestId);

        const url = `${BASE_URL}?${query.toString()}`;

        return new Promise(async (resolve, reject) => {
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Firebase-UID': token,
                    },
                    signal,
                });

                if (response.status >= 400 && response.status < 600) {
                    const errorText = await response.text();
                    throw new Error(
                        `Failed to load ECAC Departure Summary Report: ${response.status} ${errorText}`
                    );
                }

                const json = await response.json();
                resolve(json);
            } catch (error) {
                if (error.name === 'AbortError') {
                    reject(new Error('Request aborted'));
                    return;
                }
                reject(error);
            }
        });
    }

    async patchBooking(bookingId, patch) {
        const token = await getToken();
        const url = `/api/v1/bookings/bookings/patchBooking/${encodeURIComponent(bookingId)}`;
        const response = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Firebase-UID': token,
            },
            body: JSON.stringify(patch),
        });
        if (response.status >= 400 && response.status < 600) {
            const errorText = await response.text();
            throw new Error(`Failed to patch booking: ${response.status} ${errorText}`);
        }
        return response.json();
    }
}

export default new EcacDepartureSummaryReportService();
